import h from 'hyperscript';

import unrevealIcon from '@disy/cadenza-icons/visibility-off.svg';
import revealIcon from '@disy/cadenza-icons/visibility-on.svg';
import { uniqueId } from '@disy/lib/unique-id';
import { createIconButton } from '@disy/ui/button';
import '@disy/ui/form-control-wrapper.css';
import { icon } from '@disy/ui/icon';

import './password-input.css';
import i18n from './password-input.properties';

const COMPONENT_NAME = 'd-password-input';

class PasswordInput extends HTMLElement {
  _input!: HTMLInputElement;

  _revealButton = createIconButton(icon(revealIcon), i18n('reveal.title'), {
    variant: 'borderless',
    size: 'xs',
    styleClass: `${COMPONENT_NAME}--reveal-button`,
    pressed: false,
    tabIndex: -1,
    onclick: () => this._toggleReveal(),
  });

  _toggleReveal() {
    const reveal = this._revealButton.pressed;
    this._input.type = reveal ? 'text' : 'password';
    this._revealButton.innerHTML = '';
    this._revealButton.append(icon(reveal ? unrevealIcon : revealIcon));
  }

  connectedCallback() {
    this.classList.add(COMPONENT_NAME, 'form-control-wrapper');

    if (!this._input) {
      /*
       * You may pre-define the input to customize it with properties
       * that are not available through the API of this component.
       */
      this._input = this.querySelector('input[type=password]') ?? h('input', { type: 'password' });
      this._input.classList.add(`${COMPONENT_NAME}--input`, 'form-control');
      this._input.placeholder = this._input.placeholder || ' '; // We need a placeholder for :placeholder-shown to work in CSS.
      this._input.id = this._input.id || uniqueId();
      this._revealButton.setAttribute('aria-controls', this._input.id);
    }

    this.append(this._input, this._revealButton);
  }

  get value() {
    return this._input.value;
  }

  set value(value) {
    this._input.value = value;
  }

  get disabled() {
    return this._input.disabled;
  }

  set disabled(value) {
    this._input.disabled = value;
  }
}

customElements.define(COMPONENT_NAME, PasswordInput);
declare global {
  interface HTMLElementTagNameMap {
    [COMPONENT_NAME]: PasswordInput;
  }
}
